import { render } from "./CarOrderPopup.vue?vue&type=template&id=2ccfd06b"
import script from "./CarOrderPopup.vue?vue&type=script&lang=js"
export * from "./CarOrderPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__